import React from "react";
import "./mainTop.css";
import "animate.css";
import { useTranslation } from "react-i18next";
import { FaAward, FaEuroSign, FaFileContract } from "react-icons/fa6";
import { motion } from "framer-motion";

export default function MainTop() {
    const { t, i18n } = useTranslation();

    const language = i18n.language;
    const pathFolderPdf = "./pdf/";

    let docContract = "";
    let docPrice = "";
    let docWarranty = "";

    switch (language) {
        case "cs":
            docContract = "contractCS.pdf";
            docPrice = "priceCS.pdf";
            docWarranty = "warrantyCS.pdf";
            break;
        case "uk":
            docContract = "contractUK.pdf";
            docPrice = "priceUK.pdf";
            docWarranty = "warrantyUK.pdf";
            break;
        case "ru":
            docContract = "contractRU.pdf";
            docPrice = "priceRU.pdf";
            docWarranty = "warrantyRU.pdf";
            break;
        default:
    }

    const CONTRACT = pathFolderPdf + docContract;
    const PRICE = pathFolderPdf + docPrice;
    const WARRANTY = pathFolderPdf + docWarranty;

    return (
        <div className="main__top">
            <div className="main__top__container">
                <motion.div
                    className="main__top__title"
                    initial={{ y: 10 }}
                    animate={{ y: 10 }}
                    transition={{ delay: 1 }}
                >
                    <h1>{t("main_top_title")}</h1>
                </motion.div>
                <div className="main__top__text__content">
                    <p>{t("main_top_content")}</p>
                </div>
                <div className="main__top__sheet__text">
                    <ul className="sheet__text">
                        <li>{t("main_top_sheet_1")}</li>
                        <li>{t("main_top_sheet_2")}</li>
                        <li>{t("main_top_sheet_3")}</li>
                        <li>{t("main_top_sheet_4")}</li>
                        <li>{t("main_top_sheet_5")}</li>
                        <li>{t("main_top_sheet_6")}</li>
                    </ul>
                </div>
                <motion.div
                    className="main__top__contract"
                    initial={{ x: -3000 }}
                    animate={{ x: 10 }}
                    transition={{ delay: 2 }}
                >
                    <FaFileContract
                        color="#1b82f7"
                        style={{ marginRight: "1rem" }}
                        size={30}
                    />
                    <a href={CONTRACT} target="_blank" rel="noreferrer">
                        <p>{t("main_top_contract")}</p>
                    </a>
                </motion.div>
                <motion.div
                    className="main__top__contract"
                    initial={{ x: -3000 }}
                    animate={{ x: 10 }}
                    transition={{ delay: 3 }}
                >
                    <FaEuroSign
                        color="#1b82f7"
                        style={{ marginRight: "1rem" }}
                        size={30}
                    />
                    <a href={PRICE} target="_blank" rel="noreferrer">
                        <p>{t("main_top_price")}</p>
                    </a>
                </motion.div>
                <motion.div
                    className="main__top__contract"
                    initial={{ x: -3000 }}
                    animate={{ x: 10 }}
                    transition={{ delay: 4 }}
                >
                    <FaAward
                        color="#1b82f7"
                        style={{ marginRight: "1rem" }}
                        size={30}
                    />
                    <a href={WARRANTY} target="_blank" rel="noreferrer">
                        <p>{t("main_top_warranty")}</p>
                    </a>
                </motion.div>
            </div>
        </div>
    );
}
